<template>
    <div class="SharedFilesCard full-height">
        <!-- Sender Box -->
        <div v-if="status=='pending'" class="container-of-fullheight-element" style="padding: 24px;">
            <v-form  v-model="upload" class="fullheight-element">

                <p style="margin-top: 16px; font-weight: bold;">{{$t('Enter the emails with whom you want to share')}}:</p>

                <multiple-email-select v-model="emails" :user="$user" class="padding"></multiple-email-select>

                <div v-if="missing_emails && emails.length == 0" class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{$t('Select at least 1 email')}}</div>
                    </div>
                </div>

                <!-- Message to send -->
                <v-text-field class="padding"
                        v-model="message"
                        :label="$t('Message')"
                ></v-text-field>


                <!-- Permissions -->
                <v-flex xs12 class="padding checkboxes">
                    <p aria-hidden="true" class="v-label v-label--active theme--light" style="text-align: left">{{$t('Give permission to')}}</p>
                    <v-layout row wrap>
                        <v-checkbox v-if="canView" readonly v-model="permissionView" color="primary" :label="$t('View the file')"></v-checkbox>
                        <v-checkbox v-if="canDownload" v-model="permissionDownload" color="primary" :label="$t('Download the file')"></v-checkbox>
                    </v-layout>
                </v-flex>

                <div v-if="invalid_permissions" class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{$t('Invalid permissions')}}</div>
                    </div>
                </div>


                <v-switch v-model="limits" color="primary" class="padding" style="margin:0" :label="label_limits"></v-switch>
                <temporal-permissions v-if="limits" ref="temporal" v-model="temporalPermissions" class="padding"></temporal-permissions>

                <v-flex v-if="isFileOwner" xs12 class="padding checkboxes">
                    <p aria-hidden="true" class="v-label v-label--active theme--light" style="text-align: left">{{$t('Allow the user to share the file so others can')}}</p>
                    <v-layout row wrap>
                        <v-checkbox v-model="GivePermissionsView" color="primary" :label="$t('View the file')"></v-checkbox>
                        <v-checkbox v-model="GivePermissionsDownload" color="primary" :label="$t('Download the file')"></v-checkbox>
                    </v-layout>
                </v-flex>
                <div v-if="invalid_give_permissions" class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{$t("You cannot allow the user to concede a permission that doesn't have.")}}</div>
                    </div>
                </div>
                <!-- End Permissions -->


            </v-form>

            <v-layout row style="height:60px; padding-top: 10px;">
                  <v-flex xs12>
                      <div class="text-center">
                          <v-btn round center :loading="loading" :disabled="loading" color="primary" class="white--text" style="margin-bottom: 0; margin-top:0" @click="shareFile">{{$t('Share')}}
                            <v-icon right dark>cloud_upload</v-icon>
                          </v-btn>
                       </div>
                  </v-flex>
            </v-layout>
        </div>

        <!-- Successful Box -->
        <div v-else-if="status=='ok'" class="text-center">
            <v-img
                    src="https://static1.squarespace.com/static/5785112415d5db7cc123a214/5789372737c5819281d09e69/5a8c1f01e2c483ba7d016766/1530702388704/success.jpg"
                    aspect-ratio="2.75"
            ></v-img>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline mb-0">{{$t("You're done!")}}</h3>
                    <div>{{$t("Your request has been received and will be processed shortly. You will receive an email when the file has been shared (check the spam folder).")}}</div>
                </div>
            </v-card-title>
            <v-layout row>
                <v-flex xs12>
                    <div class="text-center">
                        <v-btn round center color="primary" dark @click="clear">{{$t("Send Another?")}}</v-btn>
                        <v-btn round center color="primary" dark @click="goRates">{{$t("Enterprise")}}</v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </div>

        <!-- Error Box -->
        <div v-else-if="status=='error'">
            <v-card-title primary-title>

                <div>
                    <h3 class="headline mb-0">{{$t("Oops! Something went wrong :(")}}</h3>
                </div>

                <v-expansion-panel inset style="margin-top: 10px;">
                    <v-expansion-panel-content hide-actions>
                        <template v-slot:header>
                            <div>
                                <v-btn depressed small>{{$t("See detailed errors")}}</v-btn>
                            </div>
                        </template>
                        <ul id="example-1" style="margin-left: 10px">
                            <li v-for="error in errors">
                                {{ error.message }}
                            </li>
                        </ul>
                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-card-title>

            <v-layout row>
                <v-flex xs12>
                    <div class="text-center pb-2">
                        <v-btn round center color="primary" dark @click="tryAgain">{{$t("Try again")}}</v-btn>
                    </div>
                </v-flex>
            </v-layout>

        </div>

    </div>
</template>

<script>
    import FilesRepository from '@/repositories/FilesRepository'
    import MultipleEmailSelect from '@/components/SharedFilesCard/MultipleEmailSelect'
    import TemporalPermissions from '@/components/SharedFilesCard/TemporalPermissions'
    import {VExpansionPanel, VExpansionPanelContent, VBtn,VIcon,VForm,VTextField,VFlex,VLayout,VCombobox,VImg,VCardActions,VCardTitle, VCheckbox, VSwitch} from 'vuetify/lib'
    import config from "../../config"

    export default {
        components: {VExpansionPanel, VExpansionPanelContent, MultipleEmailSelect,TemporalPermissions,VBtn,VIcon,VForm,VTextField,VFlex,VCombobox,VLayout,VImg,VCardActions,VCardTitle, VCheckbox, VSwitch},

        props: {
            fileHash: String,
            token: String,
            givePermissions: Array,
            isFileOwner: Boolean
        },

        data () {
            return {
                permissions: ['View'],
                emails:[],
                temporalPermissions:null,
                loading:false,
                message:'',
                email:'',
                upload:'',
                status:'pending',
                errors:null,
                capchaReturn:"",
                capcha:config.capcha,
                permissionView: this.givePermissions.includes('View'),
                permissionDownload: false,
                GivePermissionsView:false,
                GivePermissionsDownload:false,
                invalid_permissions: false,
                invalid_give_permissions: false,
                limits:false,
                missing_emails: false,
                canView: this.givePermissions.includes('View'),
                canDownload: this.givePermissions.includes('Download')
            }
        },
        computed:{
            label_limits:function() {
                if (this.limits) return this.$t('Limited accesses (only one allowed)');
                return this.$t('Limited accesses');
            },
            valid_send:function() {
                if (this.emails.length == 0) {
                    this.missing_emails = true;
                    console.log("Missing emails");
                    return false;
                }
                if (!this.valid_permissions()) {
                    this.invalid_permissions = true;
                    console.log("Invalid permissions");
                    return false;
                }

                if (!this.valid_give_permissions()) {
                    this.invalid_give_permissions = true;
                    return false;
                }else{
                    this.invalid_give_permissions = false;
                }

                //console.log("Valid");
                return true;
            },
        },
        methods:{
            valid_permissions:function() {
                return this.permissionView || this.permissionDownload;
            },
            valid_give_permissions: function() {
                if(this.GivePermissionsView){
                    if(!this.permissionView){
                        return false;
                    }
                }

                if(this.GivePermissionsDownload){
                    if(!this.permissionDownload){
                        return false;
                    }
                }

                return true;
            },
            send:function() {

                var POSITION_DOWNLOAD = 4;
                var POSITION_VIEW = 5;

                var permissionList = [0, 0, 0, 0, 0, 0, 0, 0];
                if (this.permissionView) {
                    permissionList[POSITION_VIEW] = 1;
                }
                if (this.permissionDownload) {
                    permissionList[POSITION_DOWNLOAD] = 1;
                }
                this.loading = true;
                var temporaryPermissionType = null;
                var temporaryPermissionValue = null;
                if (this.temporalPermissions) {
                    temporaryPermissionType = this.temporalPermissions.temporalPermission;
                    temporaryPermissionValue = this.temporalPermissions.temporalValue;
                }

                var givePermissionList= [0, 0, 0, 0, 0, 0, 0, 0];
                if (this.GivePermissionsView) {
                    givePermissionList[POSITION_VIEW] = 1;
                }
                if (this.GivePermissionsDownload) {
                    givePermissionList[POSITION_DOWNLOAD] = 1;
                }

                FilesRepository.shareFile(this.fileHash, this.emails, this.message, permissionList, temporaryPermissionType, temporaryPermissionValue, givePermissionList, this.token).then(() => {
                    this.status = 'ok';
                    this.temporalPermissions = null;
                }).catch((error) => {
                    this.errors = (Array.isArray(error.response.data)) ? error.response.data : [error.response.data];
                    this.temporalPermissions = null;
                    this.status = 'error';
                });
            },
            clear:function(){
                this.permissionView = this.givePermissions.includes('View');
                this.permissionDownload = false;
                this.GivePermissionsView = false;
                this.GivePermissionsDownload = false;

                this.emails=[];
                this.loading = false;
                this.message = '';
                this.status ='pending';
                this.limits = false;
            },
            tryAgain:function(){
                this.loading=false;
                this.status='pending';
            },
            goRates(){
                window.location = 'https://welicense.io/pricing/';
                //this.$router.push({ name: "rates"})
            },
            shareFile(){
                if(this.valid_send){
                    this.send();
                }
            }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .SharedFilesCard {
        .padding{
            padding: 0px 15px;
        }
    }

    .vue-recaptcha{
        display: inline-block;
    }
    .rc-anchor-normal-footer, .rc-anchor-invisible-text, .rc-anchor {
        display: none;
    }
    .grecaptcha-badge{
        box-shadow: none;
    }
</style>
